import Types from "./types";
import { LeadServiceJava } from "../../../service/lead-service-java-api";

const setLocationName = (locationName) => ({
    type: Types.SET_CURRENT_LOCATION_NAME,
    locationName
});

const setPlaceID = (placeID) => ({
    type: Types.SET_CURRENT_LOCATION_ID,
    placeID
});

const setSelectionType = (selectionType) => ({
    type: Types.SET_SELECTION_TYPE,
    selectionType
});
const setLeadDetailData = (data) => ({
    type: Types.FETCH_LEAD_DETAILS,
    data
});
const setFetchLeadDetail = (data) => ({
    type: Types.IS_FETCH_LEAD_DETAILS,
    data
});
const fetchLeadDetails = (token, pvtToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.fetchLeadDetailsProtected(token, {}, false, pvtToken).then(response => {
            resolve(response.data.detail);
            dispatch(setLeadDetailData(response.data.detail));
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchAppointmentDetails = (token) => () => { // todo: remove this function
    return new Promise((resolve, reject) => {
        LeadServiceJava.getAppointmentDetailsByToken(token).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchLeadDetailsProtected = (token, secureToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.fetchLeadDetailsProtected(token, {}, false, secureToken).then(response => {
            resolve(response.data.detail);
            dispatch(setLeadDetailData(response.data.detail));
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchAppointmentDetailsProtected = (token, secureToken) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getAppointmentDetailsByTokenProtected(token, secureToken).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export {
    setLocationName,
    setPlaceID,
    setSelectionType,
    fetchLeadDetails,
    fetchAppointmentDetails,
    setFetchLeadDetail,
    fetchAppointmentDetailsProtected,
    fetchLeadDetailsProtected
};
